import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AdaptedFlower, FlowerProduct } from '../../types/flowers';

interface FlowersState {
    flowers: AdaptedFlower[];
    originalFlowerProducts: FlowerProduct[];
    loading: boolean;
    error: string | null;
    cartItems: {
        [key: string]: {
            quantity: number;
            sizeId?: string;
            variantId?: number;
        };
    };
}

const initialState: FlowersState = {
    flowers: [],
    originalFlowerProducts: [],
    loading: false,
    error: null,
    cartItems: {},
};

const flowersSlice = createSlice({
    name: 'flowers',
    initialState,
    reducers: {
        setCartItems: (state, action: PayloadAction<typeof initialState.cartItems>) => {
            console.log('🛒🔧 Redux setCartItems вызван с:', action.payload);
            state.cartItems = action.payload;
            console.log('🛒🔧 Redux state.cartItems обновлен:', state.cartItems);
        },

        clearCart: (state) => {
            console.log('🛒🧹 Redux clearCart вызван');
            state.cartItems = {};
            console.log('🛒🧹 Redux корзина очищена');
        },
        setFlowersLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setFlowersError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
        setFlowers: (state, action: PayloadAction<AdaptedFlower[]>) => {
            state.flowers = action.payload;
        },
        setOriginalFlowerProducts: (state, action: PayloadAction<FlowerProduct[]>) => {
            state.originalFlowerProducts = action.payload;
        },
        addToCart: (state, action: PayloadAction<{
            flowerId: string;
            quantity: number;
            sizeId?: string;
            variantId?: number;
        }>) => {
            const { flowerId, quantity, sizeId, variantId } = action.payload;

            if (quantity <= 0) {
                delete state.cartItems[flowerId];
            } else {
                state.cartItems[flowerId] = {
                    quantity,
                    sizeId,
                    variantId,
                };
            }
        },
        updateCartItem: (state, action: PayloadAction<{
            itemId: string;
            quantity: number;
        }>) => {
            const { itemId, quantity } = action.payload;

            if (quantity <= 0) {
                delete state.cartItems[itemId];
            } else {
                if (state.cartItems[itemId]) {
                    state.cartItems[itemId].quantity = quantity;
                }
            }
        },
        clearFlowers: (state) => {
            state.flowers = [];
            state.originalFlowerProducts = [];
            state.error = null;
        },
        loadCartFromApi: (state, action: PayloadAction<any[]>) => {
            const apiProducts = action.payload;
            const restoredCart: any = {};

            apiProducts.forEach(apiProduct => {
                const flowerId = `${apiProduct.product_id}-${apiProduct.variant_id}`;

                restoredCart[flowerId] = {
                    quantity: apiProduct.qty,
                    sizeId: apiProduct.size_id,
                    variantId: apiProduct.variant_id,
                    productId: apiProduct.product_id,
                    shopId: apiProduct.shop_id,
                };
            });

            state.cartItems = restoredCart;
        },

        clearCartOnCityChange: (state) => {
            state.cartItems = {};
        },
    },
});

export const {
    setCartItems,
    setFlowersLoading,
    setFlowersError,
    setFlowers,
    setOriginalFlowerProducts,
    addToCart,
    updateCartItem,
    clearCart,
    clearFlowers,
    loadCartFromApi,
    clearCartOnCityChange
} = flowersSlice.actions;

export const flowersReducer = flowersSlice.reducer;